import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { GeneralService } from '@services/general/general.service';
import { date2string } from '@services/program-manager';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.css'],
})
export class InformationComponent {
  releaseDate = date2string(new Date());;
  appVersion;

  version: string = '';

  constructor(
    private router: Router,
    private generalService: GeneralService,
    private http: HttpClient,
  ) {
    this.generalService
      .getFirebaseResourceUrlObs('/myclinic/myclinic_info.json')
      .subscribe((url: string) => {
        this.http.get<any[]>(url).subscribe((data) => {
          try {
            this.releaseDate = data[0].myclinic_latest_release_date;
          } catch (error) {
            this.releaseDate = date2string(new Date());
          }
        })
      })


    try {
      this.version = environment.APP_VERSION_ABC ?? ',/';
      if (environment.production)
        this.version = this.version.split(',')[1].split('/')[1];
      else this.version = this.version.substring(0, 7);
    } catch (error) { }
  }

  goBack() {
    this.router.navigate(['settings']);
  }
}
